"use client";

import { forwardRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { buttonVariants } from "@/components/fun-ui/Button";
import { WechatIcon } from "@/components/fun-ui/icons";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { DemoMaskedText } from "@/components/demo/DemoMaskedText";
import { publicAsset } from "@/lib/public-assets";

const DefaultTrigger = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          buttonVariants({ variant: "outline" }),
          "ml-2 space-x-2 hidden md:flex items-center justify-center h-8 rounded-full px-5 hover:bg-primary hover:text-primary-foreground md:h-8 md:text-xs md:px-5",
          className,
        )}
        {...props}
      >
        <DemoMaskedText>
          <WechatIcon />
        </DemoMaskedText>
        <span>官方小助手</span>
      </div>
    )
  },
);

DefaultTrigger.displayName = "DefaultTrigger";

interface CommunicateWithUsProps {
  side?: "bottom" | "top" | "right" | "left"
  align?: "center" | "end" | "start"
  size?: number;
  children?: React.ReactNode
}
export function CommunicateWithUs({
  side = 'bottom',
  align = 'center',
  size = 115,
  children,
}: CommunicateWithUsProps) {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          {children ? children : <DefaultTrigger />}
        </TooltipTrigger>
        {open ? (
          <TooltipContent className="bg-background text-foreground shadow-[0px_3.2px_8px_0px_rgba(0,0,0,0.08)] border my-2 ml-1" side={side} align={align}>
            <div
              className="flex flex-col text-center justify-center px-2 py-3 space-y-2"
            >
              <Image
                alt="加入群聊二维码"
                src={publicAsset("/images/join-group-chat-qr-code.png?v=1")}
                width={size}
                height={size}
              />
              <p>微信扫描二维码</p>
            </div>
          </TooltipContent>
        ) : null}
      </Tooltip>
    </TooltipProvider >
  )
}
